import { disableChartConception } from 'helpers/features';
import { AvailableSettings, StaticSettings } from '../definitions';
import { additionalSettingsOnConceptionDisabled } from './common';

export const barSettings: (AvailableSettings | StaticSettings)[] = [
    // Axis and Labels
    ...(disableChartConception ? additionalSettingsOnConceptionDisabled : []),
    'sortDimension',
    'axisLabelFontSize',
    'xAxis',
    'xAxisTitle',
    'areTicksRotated',
    'isDataZoomEnabled',
    'yAxis',
    'yAxisTitle',
    'secondaryYAxis',
    // Legend
    'showLegend',
    'showLegendOnRightSide',
    // Value Labels
    'areLabelsShown',
    'areLabelsShownInside',
    'areLabelsVertical',
    'isEvolutionDisplayed',
    // Number Format
    'decimalPrecision',
    'displayBy',
    // Groups and Aggregates
    'isYearlyComparison',
    'isStackedBars',
    'isNormalized',
    // Goal and Thresholds
    'goalValue',
    // Colors
    'palette',
    'useGradientColor',
    'reverseGradientColor',
    'customPalette',
];
